import { Outlet } from 'react-router-dom';

import styles from './InfosMainPage.module.scss';

const InfosMainPage = () => {
  return (
    <div className={styles.container}>
      <Outlet />
    </div>
  );
};

export default InfosMainPage;
